
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16.038","height":"25.085"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Tracé 350","d":"M8.019 24.586S-8.895.5 8.019.5s0 24.086 0 24.086z","fill":"#266fea","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    